import React, { useState } from 'react'
import { Button, Chip } from '@mui/material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import createDialogTitle from '../../generic/utilities/dialogUtil'
import DocumentRepositoryRecordPicker from './DocumentRepositoryRecordPicker'

/**
 * DocumentRepositoryAssociatedRecordFilter — historia 170, HU-02 (J2), 3rd refactor round. S48's
 * record filter, restored after being retired from the UI in the 2nd round (no column-filter
 * primitive of `SmartMateriaUITable` fits a two-step topic-then-text search — that finding still
 * holds). Placed instead in the table's OWN toolbar extension point
 * (`SmartMateriaUITable`'s `toolbar={{ render: { fetchFunction } }}` — an EXISTING, non-invasive
 * extension point already used elsewhere, e.g. `configuration/parts/PartReferencePreset.jsx`;
 * `generic/SmartMateriaUIToolbar.jsx` itself is untouched by this historia).
 *
 * `recordLabel` is best-effort only: there is no "fetch one record by id" endpoint (only R3's own
 * search), so a record restored from the URL (S94/S95) shows a generic fallback label
 * (`DocumentRepository.jsx` builds it as `translated topic — referenceId`) until the user reopens
 * the picker and re-selects — at which point the real `code — name` from R3 takes over.
 * `DocumentRepository.jsx` owns `recordLabel` as its own state for exactly that reason (a value the
 * URL cannot fully restore is not this component's business to reconstruct).
 */
const DocumentRepositoryAssociatedRecordFilter = ({ topics, recordReferenceId, recordLabel, onSelect, onClear }) => {
  const { t_ } = useSmartTranslation()
  const [open, setOpen] = useState(false)
  const hasSelection = Boolean(recordReferenceId)

  const handleSelect = (topic, referenceId, record) => {
    onSelect(topic, referenceId, record)
    setOpen(false)
  }

  return (
    <>
      {hasSelection
        ? <Chip label={recordLabel} onClick={() => setOpen(true)} onDelete={onClear} />
        : <Button onClick={() => setOpen(true)}>{t_('Associated record')}</Button>}

      {open && (
        <SmartDialog
          setOpen
          title={createDialogTitle({ title: t_('Associated record') })}
          accept={false}
          cancelCallback={() => setOpen(false)}
          closeCallback={() => setOpen(false)}
          renderComponent={<DocumentRepositoryRecordPicker topics={topics} onSelect={handleSelect} />}
        />
      )}
    </>
  )
}

export default DocumentRepositoryAssociatedRecordFilter
